import * as types from '../actions/stripeActions';

const initialState = {
    ephemeralKey: null,
    customer: null,
    token: null,
    loading: false,
    error: null
}

function stripeReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_DEFAULT_CARD_REQUEST:
        case types.DELETE_CARD_REQUEST:
        case types.CREATE_TOKEN_REQUEST:
        case types.CREATE_CARD_REQUEST:
        case types.GET_CUSTOMER_REQUEST:
        case types.GET_EPHEMERAL_KEY_REQUEST:
            return Object.assign({}, state, {
                loading: true,
                error: null
            });
            break;

        case types.GET_EPHEMERAL_KEY_SUCCESS:
            console.log('look here - e key');
            console.log(action.ephemeralKey);
            return Object.assign({}, state, {
                ephemeralKey: action.ephemeralKey,
                loading: false,
                error: null
            });
            break;

        case types.CREATE_TOKEN_SUCCESS:
            return Object.assign({}, state, {
                token: action.token,
                loading: false,
                error: null
            });
            break;

        case types.CREATE_CARD_SUCCESS:
            var customer = state.customer;
            customer.sources.data.push(action.card);
            return Object.assign({}, state, {
                customer: customer,
                loading: false,
                error: null
            });
            break;

        case types.DELETE_CARD_SUCCESS:
            var customer = state.customer;
            customer.sources.data = customer.sources.data.filter((card) => card.id !== action.cardID);
            return Object.assign({}, state, {
                customer: customer,
                loading: false,
                error: null
            });
            break;

        case types.SET_DEFAULT_CARD_SUCCESS:
        case types.GET_CUSTOMER_SUCCESS:
            return Object.assign({}, state, {
                customer: action.customer,
                loading: false,
                error: null
            });
            break;

        case types.SET_DEFAULT_CARD_FAILURE:
        case types.DELETE_CARD_FAILURE:
        case types.CREATE_TOKEN_FAILURE:
        case types.CREATE_CARD_FAILURE:
        case types.GET_CUSTOMER_FAILURE:
        case types.GET_EPHEMERAL_KEY_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                error: action.error
            });
            break;

        // case types.LOGOUT:
        //     return Object.assign({}, state, initialState);
        //     break;

        default:
            return state;
    }
}

export default stripeReducer;